import { UserService } from './../../../services/user.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { StripeService } from '../../../services/stripe.service';
import { first } from 'rxjs/internal/operators/first';
import { UserNavigationComponent } from 'src/app/partials/navigation/user-navigation/user-navigation.component';
import * as jquery from 'jquery';
import { map, tap, concatMap } from 'rxjs/operators';

// stripe variable
declare var Stripe: any;

@Component({
  selector: 'app-payment-method',
  templateUrl: './payment-method.component.html',
  styleUrls: ['./payment-method.component.scss']
})
export class UserPaymentMethodComponent implements OnInit {

  @ViewChild(UserNavigationComponent) userNavigation;

  stripe: any;
  stripeKey: any;
  loading = false;
  success = false;
  error = false;
  expireYear: string;
  expireMonth: string;
  updateError = false;
  lastFourDigits: number;
  hasPaymentMethod: boolean;
  modalText = 'Loading...';

  constructor(
    private route: ActivatedRoute,
    private pageTitleService: Title,
    private stripeService: StripeService,
    private userService: UserService
  ) { }

  ngOnInit(): void {
    this.setPageTitle();
    this.loadData();

    let top = document.getElementById('top');
    if (top !== null) {
      top.scrollIntoView();
      top = null;
    }
  }

  setPageTitle() {
    this.pageTitleService.setTitle(this.route.snapshot.data.title || 'Change Payment Method');
  }

  loadData() {

    // Show progress modal
    this.showProgressModal();

    this.userService.getProfile()
      .pipe(

        // Get User Details
        map(user => user.data.user),
        tap(user => {
          this.userNavigation.user = user;
        }),

        // Get Payment Method
        concatMap(() => this.stripeService.getPaymentMethod()),
        map(paymentData => paymentData.data),
        tap(paymentData => {
          const lastId = paymentData.methods.length - 1;
          this.lastFourDigits = paymentData.methods[lastId].last4;
          this.expireMonth = paymentData.methods[lastId].exp_m;
          this.expireYear = paymentData.methods[lastId].exp_y;
        }),

        // Get Stripe
        concatMap(() => this.stripeService.getStripeKey()),
        map(stripeData => stripeData.data),
        tap(stripeData => {

          this.stripeKey = stripeData.key;
          this.stripe = Stripe(this.stripeKey);

          // Create `card` element that will watch for updates
          // and display error messages
          const style = {
            base: {
              color: '#32325d',
              lineHeight: '18px',
              fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
              fontSmoothing: 'antialiased',
              fontSize: '16px',
              '::placeholder': {
                color: '#aab7c4'
              },
            },
            invalid: {
              color: '#fa755a',
              iconColor: '#fa755a'
            }
          };

          // create the payment input box
          const elements = this.stripe.elements();
          const card = elements.create('card', {
            hidePostalCode: true,
            style
          });
          card.mount('#card-element');

          // display error
          card.addEventListener('change', event => {
            const displayError = document.getElementById('card-errors');
            if (event.error) {
              displayError.textContent = event.error.message;
            } else {
              displayError.textContent = '';
            }
          });

          // focus on element upon load of page
          card.on('ready', () => {
            //card.focus();
          });

          // Listen for form submission, process the form with Stripe,
          // and get the token id
          const paymentForm = document.getElementById('payment-form');
          paymentForm.addEventListener('submit', event => {
            event.preventDefault();
            this.stripe.createToken(card).then(result => {
              if (result.error) {
                console.log('Error creating payment method.');
                const errorElement = document.getElementById('card-errors');
                errorElement.textContent = result.error.message;
                this.loading = false;
              } else {
                // At this point, you should send the token ID
                // to your server so it can attach
                // the payment source to a customer
                // console.log('Token acquired!');
                // console.log(result.token);
                // console.log(result.token.id);
                this.loading = true;
                card.clear();
                this.savePaymentMethod(result.token.id);
              }
            });
          });

        }),

      )
      .subscribe(
        response => {
          if (response) {
            setTimeout(() => {
              // hide progress modal
              this.hideProgressModal();
            }, 500);
          }
        },
        error => {
          // hide progress modal
          this.hideProgressModal();
          this.error = true;
        }
      );
  }

  loadStripe() {
    this.stripeService.getStripeKey()
      .pipe(first())
      .subscribe(
        data => {
          this.stripeKey = data.data.key;
          this.stripe = Stripe(this.stripeKey);

          // Create `card` element that will watch for updates
          // and display error messages
          const style = {
            base: {
              color: '#32325d',
              lineHeight: '18px',
              fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
              fontSmoothing: 'antialiased',
              fontSize: '16px',
              '::placeholder': {
                color: '#aab7c4'
              },
            },
            invalid: {
              color: '#fa755a',
              iconColor: '#fa755a'
            }
          };

          // create the payment input box
          const elements = this.stripe.elements();
          const card = elements.create('card', {
            hidePostalCode: true,
            style
          });
          card.mount('#card-element');

          // display error
          card.addEventListener('change', event => {
            const displayError = document.getElementById('card-errors');
            if (event.error) {
              displayError.textContent = event.error.message;
            } else {
              displayError.textContent = '';
            }
          });

          // focus on element upon load of page
          card.on('ready', () => {
            //card.focus();
          });

          // Listen for form submission, process the form with Stripe,
          // and get the token id
          const paymentForm = document.getElementById('payment-form');
          paymentForm.addEventListener('submit', event => {
            event.preventDefault();
            this.stripe.createToken(card).then(result => {
              if (result.error) {
                console.log('Error creating payment method.');
                const errorElement = document.getElementById('card-errors');
                errorElement.textContent = result.error.message;
                this.loading = false;
              } else {
                // At this point, you should send the token ID
                // to your server so it can attach
                // the payment source to a customer
                // console.log('Token acquired!');
                // console.log(result.token);
                // console.log(result.token.id);
                this.loading = true;
                card.clear();
                this.savePaymentMethod(result.token.id);
              }
            });
          });
        },
        error => {});
  }

  // save payment method
  savePaymentMethod(token: any) {

    // Show progress modal
    this.showProgressModal();
    this.modalText = 'Saving...';

    this.stripeService.savePaymentMethod(token)
      .pipe(first())
      .subscribe(
        data => {
          // hide progress modal
          this.hideProgressModal();
          if (data.success) {
            this.getPaymentMethod();
            this.success = true;
            setTimeout(() => {
              this.success = false;
            }, 5000);
          } else {
            this.updateError = true;
            setTimeout(() => {
              this.updateError = false;
            }, 4000);
          }
        },
        error => { console.log(error);
          // hide progress modal
          this.hideProgressModal();
          this.error = true;
        }
      );
  }

  // get latest payment method
  getPaymentMethod() {
    this.stripeService.getPaymentMethod()
      .subscribe(
        paymentData => {
          if (paymentData.success) {
            const lastId = paymentData.data.methods.length - 1;
            this.lastFourDigits = paymentData.data.methods[lastId].last4;
            this.expireMonth = paymentData.data.methods[lastId].exp_m;
            this.expireYear = paymentData.data.methods[lastId].exp_y;
          }
          this.loadStripe();
        },
        error => {
          // hide progress modal
          this.hideProgressModal();
          this.error = true;
        }
      );
  }

  private showProgressModal() {
    jquery('#loaderSpin').show();
  }

  private hideProgressModal() {
    jquery('#loaderSpin').hide();
  }

}
